import {MessageCodes} from "../MessageCodes";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultRow from "../../../components/table/ResultRow";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import EmptyLine from "../EmptyLine";
import ResultBody from "../../../components/table/ResultBody";

export function C3({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
            {/*<Footnote assoc_data={data?.assoc_data} />*/}
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.NC001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) {row?.data?.length === 1 ? 'culvert' : 'culverts'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} added.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.NC002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) {row?.data?.length === 1 ? 'culvert' : 'culverts'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} removed.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.NC003.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) {row?.data?.length === 1 ? 'bridge' : 'bridges'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} added.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.NC004.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) {row?.data?.length === 1 ? 'bridge' : 'bridges'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} removed.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.NC005.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline {row?.data?.length === 1 ? 'structure' : 'structures'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} added.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.NC006.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline {row?.data?.length === 1 ? 'structure' : 'structures'} at the following river stations {row?.data?.length === 1 ? 'is' : 'are'} removed.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(12), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(28), textAlign: 'start'}}>Description</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                    <ResultBodyCell>{r?.description || ''}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.C3_CST07.error_id: {
            return (
                <>
                    <ResultText>
                        River stations of the following {row?.data?.length} structures are revised due to replacement within {settings?.defaults?.struc_assoc} ft proximity. They are associated as follows for comparison purposes.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3}>Associated Structures</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.sel_plan_title}</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.tar_plan_title}</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>Structure Type</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => {

                                return (
                                    <ResultRow>
                                        <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                        <ResultBodyCell>{r?.assoc_cross_section}</ResultBodyCell>
                                        <ResultBodyCell>{r?.type}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.C3_CST08.error_id: {
            return (
                <>
                    <ResultText>
                        River stations of the following {row?.data?.length} structures are revised due to realignment of the stream centerline. They are associated as follows for comparison purposes.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3}>Associated Structures</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.sel_plan_title}</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>{globalVariables?.tar_plan_title}</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>Structure Type</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {row?.data?.map(r => {

                                return (
                                    <ResultRow>
                                        <ResultBodyCell>{r?.cross_section}</ResultBodyCell>
                                        <ResultBodyCell>{r?.assoc_cross_section}</ResultBodyCell>
                                        <ResultBodyCell>{r?.type}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const Footnote = ({assoc_data}) => {
    if(assoc_data?.length === 0) {
        return (<></>)
    }
    return (
        <>
            {
                assoc_data?.map(c => (
                    <ResultText>
                        The {c?.type} at RS {c?.cross_section} is replaced with {c?.type} at RS {c?.assoc_cross_section} at {c?.assoc_diff} ft {c?.direction} of the original location.  They are associated for comparison purposes.
                    </ResultText>
                ))
            }
        </>
    )
}